import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddSalesDTO } from "../../dtos/sales";
import SalesService from "./salesService";
import { ReturnMedicineDTO } from "../../dtos/batch";


// Define initial state
const initialState = {
  salesDetails: [],
  medicineBatchListDetails: [],
  salesId: "",
  isLoading: false,
  isMedBatchLoading: false,

  isSuccess: false,
  isMedBatchSuccess: false,

  isError: false,
  isMedBatchError: false,
  
  message: <any>"",
  medBatchMessage: <any>"",
  isSalesLoading: false,
  isSalesLoadingError: false,
};

// export const AddSales = createAsyncThunk(
//   "api/pharmacy/sales/add",
//   async (sales: AddSalesDTO, thunkAPI) => {
//     try {
//       return await SalesService.AddSales(sales);
//     } catch (error: any) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );
export const AddSales = createAsyncThunk(
  "api/pharmacy/sales/add",
  async ({ pharmacy_id, salesPayload }: { pharmacy_id: any, salesPayload: any }, thunkAPI) => {
    try {
      const response = await SalesService.AddSales(pharmacy_id, salesPayload);
      return response;
    } catch (error :any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const EditSales = createAsyncThunk(
  "api/pharmacy/sales/edit",
  async ({ pharmacy_id, salesPayload }: { pharmacy_id: any, salesPayload: any }, thunkAPI) => {
    try {
      const response = await SalesService.EditSales(pharmacy_id, salesPayload);
      return response;
    } catch (error :any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const AddReturnSales = createAsyncThunk(
  "api/pharmacy/sales/add",
  async (returnSalesPayload: ReturnMedicineDTO, thunkAPI) => {
    try {
      const response = await SalesService.AddReturnSales(returnSalesPayload);
      return response;
    } catch (error :any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);



export const getSalesData = createAsyncThunk(
  "sales/getSalesData", 
  async (pharmacy_id: any, thunkAPI) => {
    try {
      const response = await SalesService.getSales(pharmacy_id); 
      return response.data; 
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getMedicineBatchList = createAsyncThunk(
  "pharmacy/batch/get_product_detail", 
  async ({medicine_id, pharmacy_id}:{ medicine_id: any, pharmacy_id: any}, thunkAPI) => {
    try {
      const response = await SalesService.getMedicineBatchList(medicine_id, pharmacy_id); 
      return response.data; 
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);



// export const getAllSalesData = createAsyncThunk(
//   "sales/getAllSalesData", 
//   async (_, thunkAPI) => {
//     try {
//       const response = await SalesService.getAllSales(); 
//       return response.data; 
//     } catch (error: any) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );

export const salesSlice = createSlice({
  name: "salesSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeSalesId: (state, action) => {
      state.salesId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getSalesData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSalesData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.salesDetails = action.payload;
        state.message = "";
      })
      .addCase(getSalesData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(getMedicineBatchList.pending, (state) => {
        state.isMedBatchLoading = true;
      })
      .addCase(getMedicineBatchList.fulfilled, (state, action) => {
        state.isMedBatchLoading = false;
        state.isMedBatchSuccess = true;
        state.medicineBatchListDetails = action.payload;
        state.medBatchMessage = "";
      })
      .addCase(getMedicineBatchList.rejected, (state, action) => {
        state.isMedBatchLoading = false;
        state.isMedBatchError = true;
        state.medBatchMessage = action.payload;
      });
  },
});

// Export actions and reducer
export const { reset, changeSalesId } = salesSlice.actions;
export default salesSlice.reducer;